module.exports = __webpack_public_path__ + "static/media/icon_stopwatch.38541094.svg";